import { render } from "./AddArticle.vue?vue&type=template&id=26e9269a"
import script from "./AddArticle.vue?vue&type=script&lang=js"
export * from "./AddArticle.vue?vue&type=script&lang=js"

import exportComponent from "E:\\moneyman\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__